import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Result } from "../interfaces/common.interface";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class TokenService {
    private basePath = `${environment.url}/token`;

    constructor(private http: HttpClient) {}

    decrypt$(enc: string): Observable<string> {
        return this.http.get<Result<string>>(`${this.basePath}/decrypt?enc=${enc}`).pipe(map((res) => res.data));
    }
}
